export default "__VITE_ASSET__BfEtTrp2__"